import { FC } from "react";

export const ChevronDownIcon: FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      width="15"
      height="10"
      viewBox="0 0 15 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className || ""}`}
    >
      <path
        d="M7.5 9.83203L0 2.19952L1.34375 0.832031L7.5 7.12885L13.6562 0.863833L15 2.23132L7.5 9.83203Z"
        fill="white"
      />
    </svg>
  );
};
